export default (content) => navigator?.clipboard?.writeText(content);
